import { render } from "./BackerCenterPaymentsSkeleton.vue?vue&type=template&id=10a81ee2"
import script from "./BackerCenterPaymentsSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__